import { get } from "lodash-es";
import React from "react";
import { postRequestWorkHistory } from "../../apis/work-request";
import { getApprobalListByParam } from "../../utils/approval";
import { dateToFormat, dateToViewFormat, formatHourSecond, getDay, getFormatHour } from "../../utils/date";
const getTask = async ({ mode, defaultData }) => {

  const getTitle = (form = { dates: [getDay()] }) => {
    return `${form.dates[0]} 출퇴근 정정 요청`;
  };
  const fields = [
    {
      title: "기준일",
      key: "dates",
      type: "datepicker",
      required: true,
      width: 313,
      detail: 'component',
      component: ({ form }) => {
        const start = form.dates[0];
        return <>{dateToViewFormat(start)}</>;
      },
      onChanged: ({ form, onChange }) => {
        if (mode !== "create") return;
        const title = getTitle(form);
        onChange({ target: { name: "title", value: title } });
      }
    },
    {
      title: "정정시간",
      key: "times",
      type: "timepicker",
      isRange: true,
      required: true,
      detail: 'component',
      component: ({ form }) => {
        const start = form.dates[0];
        const end = form.dates[1];
        return <>{getFormatHour(start)} ~ {getFormatHour(end)}</>;
      }
    },
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "사유",
      key: "description",
      type: "textarea",
      required: true,
    },
    {
      title: "첨부파일",
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    dates: [
      get(defaultData, 'data.workRequest.workStartTime', getDay()),
      ...mode !== 'create' ? [get(defaultData, 'data.workRequest.workEndTime')] : [],
    ],
    ...(mode === "create" ? {
      times: {
        from: defaultData?.data?.workRequest?.workEndTime ? dateToFormat(defaultData?.data?.workRequest?.workStartTime, formatHourSecond) : '',
        to: defaultData?.data?.workRequest?.workEndTime ? dateToFormat(defaultData?.data?.workRequest?.workEndTime, formatHourSecond) : '',
      },
    } : {}),
    title: get(defaultData, 'data.workRequest.title', getTitle()),
    description: get(defaultData, 'data.workRequest.description', ""),
    uploadFiles: get(defaultData, 'data.vacationRequest.uploadFiles', []),
  };

  const create = (form) => {
    const params = {
      title: form.title,
      description: form.description,
      histories: [{
        commuteStartTime: `${form.dates[0]} ${form.times.from}`,
        commuteEndTime: `${form.dates[0]} ${form.times.to}`,
      }],
      uploadFiles: form.uploadFiles,
      apprList: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };

    //console.log(params)
    return postRequestWorkHistory(params);
  };

  const validate = (form) => {
    let errors = {};
    if (form.times.from >= form.times.to) {
      errors['times'] = '종료시간은 시작시간보다 작거나 같을 수 없습니다.';
    }
    if (!form.times.to) {
      errors['times'] = '종료시간은 필수입니다.';
    }
    if (!form.times.from) {
      errors['times'] = '시작시간은 필수입니다.';
    }
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };

};

export default getTask;